import React from 'react';

import CricketTeamPortfolio from './components/CricketTeamPortfolio';
import './App.css';

function App() {
  return (
    <div className="App">
      <CricketTeamPortfolio />
    </div>
  );
}

export default App;